import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { CloseInputIcon, TopArrowIcon } from '../svgIcon';

function SelectBoxNew(props) {
  const {
    name,
    label,
    required,
    placeholder,
    onchange,
    lists,
    value,
    error,
    isHovered,
    errorMessage,
    closeButton,
  } = props;

  const reference = useRef(null);
  const inputRef = useRef(null);

  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState(value);
  const [searchOption, setSearchOptions] = useState(lists);
  const [style, setStyle] = useState({});

  const onSearch = (e) => {
    setSearchValue(e.target.value);
    setSearchOptions(lists.filter((list) => list?.label?.toLowerCase().includes(e.target.value.toLowerCase())));
  };

  const selectOption = (selectValue) => {
    onchange(name, selectValue);
    setOpen(false);
  };
  const clearData = () => {
    onchange(name, {});
    setSearchValue('');
    setOpen(false);
  };

  const selectOptionOpen = (event) => {
    setOpen(true);
    setSearchValue(typeof value === 'object' ? value?.label : value);
    setSearchOptions(lists);
    let rect;
    if (event.target.className === 'select-box') {
      rect = event.target.getBoundingClientRect();
    } else {
      rect = event.target.closest('.select-box').getBoundingClientRect();
    }
    if (rect.top + rect.height + 285 > window.innerHeight) {
      setStyle({
        bottom: window.innerHeight - rect.top,
        left: rect.left,
        width: rect.width,
      });
    } else {
      setStyle({
        top: rect.top + rect.height,
        left: rect.left,
        width: rect.width,
      });
    }

    setTimeout(() => {
      inputRef?.current?.focus();
    }, 500);
  };

  const handleClickOutside = (event) => {
    if (reference.current && !reference.current.contains(event.target)) {
      setOpen(false);
    }
  };

  // useEffect(() => {
  //   if (document.getElementsByClassName('dashboard-wrap')[0]) {
  //     if (open) {
  //       document.getElementsByClassName('dashboard-wrap')[0].style.overflow = 'hidden';
  //     } else {
  //       document.getElementsByClassName('dashboard-wrap')[0].style.overflow = 'scroll';
  //     }
  //   }
  // }, [open]);

  useEffect(() => {
    if (!isHovered) {
      setOpen(isHovered);
    }
  }, [isHovered]);
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
  }, []);
  return (
    <div className="select-box-wrap">
      {label && (
        <label className="label" htmlFor={name}>
          {label}{required && <span className="text-danger">*</span>}
        </label>
      )}
      <div className="input-select-box">
        <div className={`select-box ${open ? 'active' : ''}`}>
          {
            open ? (
              <div className="select-box-search" onClick={selectOptionOpen} role="presentation">
                <input
                  type="text"
                  placeholder={placeholder}
                  onChange={onSearch}
                  value={searchValue}
                  ref={inputRef}
                  style={{ width: style.width - 60 }}
                />
              </div>
            ) : (
              <div className="select-box-value-wrap" onClick={selectOptionOpen} role="presentation">
                {
                  value
                    ? (
                      <div className="select-box-value">
                        {typeof value === 'object' ? value?.label : value}
                      </div>
                    )
                    : <div className="select-box-placeholder">{placeholder}</div>
                }
              </div>
            )
          }
          {
            value && (
              <span
                onClick={clearData}
                role="presentation"
                style={{
                  display: closeButton ? 'none' : 'flex',
                }}
              >
                <CloseInputIcon />
              </span>
            )
          }
          <div className="select-box-icon" onClick={selectOptionOpen} role="presentation">
            <TopArrowIcon />
          </div>
        </div>
        {
          open && ReactDOM.createPortal(
            <div className="select-box-options" style={style} ref={reference}>
              {/* {
                searchOption.map((list) => (
                  <div className="select-box-option" onClick={() => selectOption(list)} role="presentation">
                    {list.icon && <list.icon />} {list?.label}
                  </div>
                ))
              } */}
              {/* {
                searchOption.map((list) => (
                  <div
                    key={list.id}
                    className={`select-box-option ${list.className}`}
                    onClick={() => selectOption(list)}
                    role="presentation"
                  >
                    {list.icon && <list.icon className={`icon-animation ${list.className}`} />}
                    {list?.label}
                  </div>
                ))
              } */}
              {
                searchOption.map((list) => (
                  <div
                    key={list.id}
                    className="select-box-option"
                    onClick={() => selectOption(list)}
                    role="presentation"
                  >
                    {list.icon && (
                      <span className={list.className}> {/* Wrap icon inside a span */}
                        <list.icon />
                      </span>
                    )}
                    {list?.label}
                  </div>
                ))
              }
              {
                searchOption.length === 0 && (
                  <div
                    className="select-box-option"
                  >
                    Data No Found
                  </div>
                )
              }
            </div>,
            document.body,
          )
        }
      </div>
      {error && <p className="error-message">{errorMessage}</p>}
    </div>
  );
}

SelectBoxNew.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool.isRequired,
  lists: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ])),
  // readonly: PropTypes.bool,
  // disabled: PropTypes.bool,
  value: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.bool,
  closeButton: PropTypes.bool,
  isHovered: PropTypes.bool,
  errorMessage: PropTypes.string,
};

SelectBoxNew.defaultProps = {
  // readonly: false,
  // disabled: false,
  value: '',
  label: '',
  lists: [],
  placeholder: '',
  error: false,
  closeButton: false,
  isHovered: false,
  errorMessage: '',
};

export default SelectBoxNew;
